<template>
  <div>
    <div class="row" v-if="loaded">
      <div class="col-md-3">
        <div class="card card-primary pull-right">
          <div class="card-heading" style="padding: 15px; font-size: 18px; font-weight: bold">
            Configurar Posições
          </div>

          <div class="card-body">
            <div class="row">
              <div class="col-md-12 centered">
                <button class="btn btn-add pull-right" id="v-step-1" @click="addPlace">
                  <i class="fas fa-map-pin"></i> Nova Posição
                </button>

                <button class="btn btn-add pull-right m-r-sm" id="v-step-2" @click="save">
                  <i class="fas fa-save"></i> Salvar Posições
                </button>

                <!-- <button
                    class="btn btn-add pull-right mt-2"
                    @click="openModalPlace"
                  >
                    <i class="far fa-edit"></i> Editar Posição
                  </button> -->
              </div>
              <div class="col-md-12 centered">
                <router-link to="/workstations" class="btn btn-back centered mt-3">
                  <i class="fa fa-arrow-left"></i> Voltar
                </router-link>
              </div>

              <div class="col-md-12 centered mt-3"></div>
            </div>
          </div>
        </div>
        
        <div class="card card-primary pull-right" v-if="Object.keys(elementSelected).length">
          <div class="card-heading" style="padding: 15px; font-size: 18px; font-weight: bold">
            Editar Posição
          </div>

          <div class="row justify-content-center">
            <div class="col-md-11">
              <div class="row">
                <div class="col-md-12">
                  <label for="position-title" id="v-step-3">Nome da Posição:</label>
                  <input type="text" id="position-title" class="form-control" v-model="elementSelected.title" />
                </div>
              </div>
            </div>
            <div class="col-md-11 mt-3">
              <div class="form-group">
                <label for="WorkstationDetails" id="v-step-4">Contém na Posição:</label>
                <br />
              </div>
            </div>
            <div class="col-md-4 mt-1 mb-1 ml-1 mr-1 centered" style="text-align: center; lg-check"
              v-for="detail in details" :key="detail.id">
              <input type="checkbox" :value="detail.id" v-model="checkeds" :id="detail.id" />
              <label :for="detail.id">{{ detail.title }}</label>
            </div>
            <div class="col-md-11 mt-3">
              <div class="form-group">
                <label for="UsersGroups">Grupos que podem reservar:</label>
                <v-select 
                  multiple 
                  label="title" 
                  v-model="selectedUsersGroups" 
                  :options="usersGroups"
                  placeholder="Selecione os grupos..."
                ></v-select>
                <small class="form-text text-muted">Se nenhum grupo for selecionado, todos os grupos poderão reservar esta posição.</small>
              </div>
            </div>
            <div class="col-md-11">
              <div class="row centered">
                <div class="col-md-12 mt-3 mb-3">
                  <button type="button" class="btn btn-block btn-add" data-dismiss="modal"
                    @click="savePosition(elementSelected.id)">
                    <i class="fas fa-save" id="v-step-5"></i> Salvar
                  </button>
                </div>
              </div>
            </div>

            <div class="col-md-11">
              <div class="row centered">
                <div class="col-md-12 mt-3 mb-3">
                  <button type="button" class="btn btn-block btn-delete" data-dismiss="modal"
                    @click="removeComponent(selected)">
                    <i class="fas fa-trash" id="v-step-6"></i> Deletar Posição
                  </button>
                </div>
              </div>
            </div>
            <div class="col-md-11">
              <div class="row centered">
                <div class="col-md-12 mt-3 mb-3">
                  <b-button v-b-modal.modal-1 variant="btn btn-add">Bloqueios da Posição</b-button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="col-md-9">
        <div class="row justify-content-center mt-2">
          <button class="btn btn-add" id="v-step-0" @click="startTour">
            Iniciar Tour de Cadastro de Posições
          </button>
        </div>
        <br />
        <div class="col-md-12">
          <div class="alert alert-info">
            <strong>ATENÇÃO!</strong> Alteração na posição já cadastrada, pode
            afetar o QRCode na hora de afetuar o Check-In!
          </div>
        </div>
        <div class="card">
          <div class="card-heading" style="padding: 15px; font-size: 18px; font-weight: bold">
            Workstation {{ workstation.title }}
          </div>
          <div class="card-body">
            <div class="row">
              <div class="col-md-12 mb-5">
                <div class="btn-group" role="group" aria-label="Basic example">
                  <button type="button" class="btn btn-sm btn-secondary active" style="font-size: 12px; font-weight: bold"
                    @click="minButton" id="v-step-8">
                    <i class="fa fa-search-minus" aria-hidden="true"></i>
                    Diminuir Botão
                  </button>
                  <button type="button" class="btn btn-sm btn-secondary" style="font-size: 12px; font-weight: bold"
                    @click="maxButton" id="v-step-9">
                    <i class="fa fa-search-plus" aria-hidden="true"></i>
                    Aumentar Botão
                  </button>
                </div>
              </div>
              <div class="col-md-12">
                <div class="top-container" style="border: 0px solid #f0f0f0; margin-top: -15px">
                  <img :src="workstation.blueprint" v-on:load="onLoaded" class="image-size img-responsive"
                    style="top: 0; left: 0" />
                  <VueDragResize ref="draggable" v-for="(element, index) in elements" :key="index" :isActive="true"
                    :w="Number(wButton)" :h="Number(hButton)" :x="parseFloat(element.left)" :y="parseFloat(element.top)"
                    :minw="Number(wButton)" :minh="Number(hButton)" v-on:resizing="resize($event, index)"
                    v-on:dragging="resize($event, index)" :parentLimitation="true" class="text-center"
                    :isResizable="false">
                    <button type="button" :class="isSelected && index == selected
                        ? 'btnD btn-info'
                        : 'btnD btn-secondary'
                      " :style="'z-index: 1000 !important; width: ' +
                      wButton +
                      '; height: ' +
                      hButton
                      " data-toggle="tooltip" data-placement="top" :title="element.title"
                      @click="selectPlace(index, element)">
                      <i class="fas fa-arrows-alt" :style="'font-size: ' + fontSizeButton + 'px;'"></i>
                    </button>
                    <!-- <button
                    type="button"
                    class="btn btn-primary"
                    style="z-index: 1000 !important"
                    data-toggle="tooltip"
                    data-placement="bottom"
                    :title="element.title"
                    @click="openModalPlace(index, element)"
                  >
                    <i class="fas fa-hand-pointer"></i>
                  </button> -->
                  </VueDragResize>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div class="row" v-else>
      <div class="col-md-12 text-center">
        <i class="fas fa-spinner fa-spin fa-5x"></i>
      </div>
    </div>
    <!-- Modal Bloqueio -->

    <b-modal id="modal-1" size="lg" title="Bloqueios por Posição" :hide-footer="true" v-if="Object.keys(elementSelected).length">
          <div class="modal-body">
            <div class="col-md-12">
              <div class="card">
                <div class="card-header">
                  <div class="card-title">Gerenciar Bloqueios da Posição</div>
                </div>
                <div class="card-body">
                  <div class="row">
                    <div class="col-md-12">
                      <div class="alert alert-info" role="alert">
                        Ao gerar um bloqueio esta posição não ficará disponível
                        para reservas no período informado. Para gerar um
                        bloqueio de período, selecione a data e hora de início e
                        a data e hora de fim e clique em
                        <strong>Gerar Bloqueio</strong>. <br /><br />
                        <strong>Observação: Reservas efetuadas ANTES da criação do
                          bloqueio, não serão canceladas automaticamente. Favor
                          entre em contato com o responsável e alinhe o
                          cancelamento manual.</strong>
                      </div>
                    </div>
                    <div class="col-md-12">
                      <div class="row justify-content-center">
                        <div class="col-md-6">
                          <div class="form-group">
                            <label for="inputPlace">Data Início</label>
                            <VueCtkDateTimePicker minute-interval="30" color="#4b2e8f" button-now-translation="Hoje"
                              button-color="#4b2e8f" :format="'YYYY-MM-DD HH:mm'" no-label label="Selecione..."
                              v-model="lock.date_start" />
                          </div>
                        </div>
                        <div class="col-md-6">
                          <div class="form-group">
                            <label for="inputPlace">Data Final</label>
                            <VueCtkDateTimePicker minute-interval="30" color="#4b2e8f" button-now-translation="Hoje"
                              button-color="#4b2e8f" :format="'YYYY-MM-DD HH:mm'" no-label label="Selecione..."
                              v-model="lock.date_end" />
                          </div>
                        </div>
                        <div class="col-md-12">
                          <button class="btn btn-add" data-dismiss="modal" aria-label="Close" @click="lockRoom">
                            Gerar Bloqueio
                          </button>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div class="col-md-12">
              <div class="card">
                <div class="card-header">
                  <div class="card-title">Bloqueios Cadastrados</div>
                </div>
                <div class="card-body">
                  <div class="row">
                    <div class="col-md-12">
                      <div class="alert alert-info" role="alert">
                        Aqui você visualiza os bloqueios já cadastrados, você
                        poderá excluí-los e assim tornar automaticamente
                        disponível para reservas.
                      </div>
                    </div>
                    <div class="col-md-12">
                      <div class="row justify-content-center">
                        <div class="col-md-12">
                          <table class="table" style="font-size: 14px">
                            <thead>
                              <tr>
                                <th scope="col">#</th>
                                <th scope="col">Data Inicio</th>
                                <th scope="col">Data Fim</th>
                                <th scope="col">Criado por</th>

                                <th scope="col">Ação</th>
                              </tr>
                            </thead>
                            <tbody>
                              <tr v-for="lock in elementSelected.lock" :key="lock.id">
                                <td>{{ lock.id }}</td>
                                <td>{{ lock.date_start }}</td>
                                <td>{{ lock.date_end }}</td>
                                <td>{{ lock.user.name }}</td>
                                <td>
                                  <button class="btn btn-add" data-dismiss="modal" aria-label="Close"
                                    @click="deleteLockRoom(lock.id)">
                                    <i class="fas fa-trash-alt"></i>
                                  </button>
                                </td>
                              </tr>
                              <tr v-if="elementSelected.lock.length == 0">
                                <td colspan="8" align="center">
                                  Nenhum registro encontrado.
                                </td>
                              </tr>
                            </tbody>
                          </table>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
        </div>
    </b-modal>


    <v-tour name="myTour" :steps="steps">
      <template slot-scope="tour">
        <transition name="fade">
          <v-step v-if="tour.currentStep === index" v-for="(step1, index) of tour.steps" :key="index" :step="step1"
            :previous-step="tour.previousStep" :next-step="tour.nextStep" :stop="tour.stop" :skip="tour.skip"
            :is-first="tour.isFirst" :is-last="tour.isLast" :labels="tour.labels">
            <template>
              <div slot="actions">
                <button v-if="tour.currentStep != 0" @click="tour.previousStep" class="btn-step-back">
                  Anterior
                </button>
                <button @click="cancelTour(tour.currentStep)" class="btn-step-back">
                  Pular tour
                </button>
                <button @click="
                  nextTour(
                    tour.currentStep,
                    tour.steps[index + 1],
                    tour.steps[index]
                  )
                  " v-if="tour.currentStep != 9" class="btn-step">
                  Próximo
                </button>
                <button @click="cancelTour(tour.currentStep)" v-else class="btn-step">
                  Finalizar
                </button>
              </div>
            </template>
          </v-step>
        </transition>
      </template>
    </v-tour>
  </div>
</template>

<script>
import VueDragResize from "vue-drag-resize";
import vSelect from "vue-select";

export default {
  name: "example",
  data: function () {
    return {
      lock: {},
      wButton: 40,
      hButton: 28,
      fontSizeButton: 10,
      loaded: false,
      workstation: {
        title: "",
        photo: "",
        blueprint: "",
        equipments: [],
        places: [
          {
            details: [],
          },
        ],
      },
      steps: [
        {
          target: "#v-step-0", // We're using document.querySelector() under the hood
          header: {
            title: "Cadastrar Posições na Estação de Trabalho!",
          },
          params: {
            enableScrolling: false,
          },
          content: `Clique em <strong>próximo</strong> para continuar no tour. Caso não queira esse acompanhamento, clique em <strong>Pular tour</strong>. Se preferir poderá ver esse tour guiado a qualquer momento no botão destacado no menu superior.`,
        },
        {
          target: "#v-step-1",
          params: {
            enableScrolling: false,
          },
          content:
            "Clicando em Nova Posição aparecerá um ícone no mapa, basta você clicar e segurar com o botão direito do mouse e arrastar para onde você desejar.",
        },
        {
          target: "#v-step-2",
          params: {
            enableScrolling: false,
          },
          content:
            "Após você clicar em Nova Posição, você clica em Salvar Posições para que as Posições que você cadastrou fique salva na planta da Estação. Antes de clicar em <strong>Próximo</strong> primeiro clique sobre a posição que você salvou e em seguida clique em <strong>Próximo</strong> para podermos prosseguimos com o tour.",
        },
        {
          target: "#v-step-3",
          params: {
            enableScrolling: false,
          },
          content: "Aqui você pode inserir um Nome para sua Posição.",
        },
        {
          target: "#v-step-4",
          params: {
            enableScrolling: false,
          },
          content: "Aqui você pode inserir o que contém nessa Posição.",
        },
        {
          target: "#v-step-5",
          params: {
            enableScrolling: false,
          },
          content:
            "Inserindo o nome e o que contém na posição é so clicar em Salvar.",
        },
        {
          target: "#v-step-6",
          params: {
            enableScrolling: false,
          },
          content:
            "Caso você deseje excluir uma posição, você pode deleta-la clicando nesse botão.",
        },
        {
          target: "#v-step-7",
          params: {
            enableScrolling: false,
          },
          content:
            "Caso você queira deixar a Posição bloqueada por um periodo você pode bloquear esta posição inserindo a Data de ínicio do bloqueio e Data Final do bloqueio.",
        },
        {
          target: "#v-step-8",
          params: {
            enableScrolling: false,
          },
          content:
            "Caso você queira deixar o botão da Posição menor basta clicar nesse botão..",
        },
        {
          target: "#v-step-9",
          params: {
            enableScrolling: false,
          },
          content:
            "Caso você queira deixar o botão da Posição maior basta clicar nesse botão.",
        },
      ],
      checkeds: [],
      details: {
        selected: "",
      },
      width: 0,
      height: 0,
      top: 0,
      left: 0,
      selected: "",
      isSelected: false,
      elements: [],
      elementSelected: [],
      card_height: 0,
      workstation_id: "",
      delay: 700,
      clicks: 0,
      timer: 1000,
      selectedUsersGroups: [],
      usersGroups: [],
    };
  },
  components: {
    VueDragResize,
    vSelect,
  },
  methods: {
    cancelTour(step) {
      const self = this;
      self.$tours["myTour"].skip();
      self.$store.commit("skipTour");

      let data = { finished_step: step };

      const api = self.$store.state.api + "user/finish-tour";

      self.$http.post(api, data).then((response) => { });
    },
    nextTour(step, actual_target, previous_target) {
      const self = this;

      if (step >= 31) {
        if (step >= 31) {
          $(previous_target.target).toggleClass("activeMenu");
        }
        $(actual_target.target).toggleClass("activeMenu");
      }

      if (step == 31) {
        $("#sidebar").toggleClass("active");
        setTimeout(function () {
          self.$tours["myTour"].nextStep();
        }, 500);
      } else if (step == 31) {
        $("#pagCads").toggleClass("active");
        setTimeout(function () {
          self.$tours["myTour"].nextStep();
        }, 500);
      } else if (step == 31) {
        $("#sidebar").toggleClass("active");
        $("html, body").animate({ scrollTop: 0 }, 0);
        self.$tours["myTour"].nextStep();
      } else {
        self.$tours["myTour"].nextStep();
      }
    },
    startTour() {
      let self = this;
      self.$tours["myTour"].start();
    },
    maxButton() {
      if (this.wButton < 40) {
        this.hButton++;
        this.wButton = Number(this.wButton) + Number(2);
      }
    },
    minButton() {
      if (this.wButton > 19) {
        this.hButton--;
        this.wButton = Number(this.wButton) - Number(2);
      }
    },
    onLoaded() {
      const self = this;
      self.elements = self.sizeTreatment(self.workstation.places);
    },

    getWorkstation: function () {
      const self = this;
      let id = self.$route.params.id;
      const api =
        self.$store.state.api + "workstations/" + id + "?with[]=places";
      self.$http
        .get(api)
        .then((response) => {
          self.workstation = response.data.data[0];
          self.wButton = self.workstation.wButton;
          self.hButton = self.workstation.hButton;
          self.getWorkstationDetails();
        })
        .then(() => {
          self.loaded = true;
        })
        .catch((error) => {
          self.$error(
            "Ocorreu um erro ao buscar as informações da Estação de Trabalho"
          );
        });
    },
    getWorkstationDetails: function (id) {
      const self = this;
      const api =
        self.$store.state.api +
        "workstation_details/?paginated=false&company_id=" +
        self.workstation.company_id;

      self.$http
        .get(api)
        .then((response) => {
          self.details = response.data.data;
        })
        .catch((error) => {
          self.$message(null, error.response.data, "error");
        });
    },
    resize: function (newRect, index) {
      this.elements[index].width = newRect.width;
      this.elements[index].height = newRect.height;
      this.elements[index].top = newRect.top;
      this.elements[index].left = newRect.left;
    },
    addPlace: function () {
      const self = this;
      let background = $(".image-size");
      let obj = {
        left: 0,
        top: 0,
        width: 30,
        height: 30,
        active: false,
        details: self.workstation.details_id,
        workstation_id: self.workstation.id,
        screen_width: background.width(),
        screen_height: background.height(),
      };
      self.elements.push(obj);
    },
    openModalPlace() {
      $("#modalPlace").modal("show");
    },
    selectPlace(index, element) {
      const self = this;
      console.log(element);
      if (element.id != self.elementSelected.id) {
        console.log('entrou 1');
        this.selected = index;
        this.elementSelected = element;
        this.isSelected = true;

        this.checkeds = [];

        element.details.forEach((el) => {
          self.checkeds.push(el);
        });

        // Carregar grupos de usuários da posição
        if (element.id) {
          this.loadPlaceUsersGroups(element.id);
        } else {
          this.selectedUsersGroups = [];
        }
      } else {
        console.log('entrou 2');
        this.selected = "";
        this.elementSelected = {};
        this.isSelected = false;
        this.checkeds = [];
        this.selectedUsersGroups = [];
      }

      // $("#modalPlace").modal("show");
    },
    savePosition(element) {
      console.log(element);
      console.log(this.checkeds);
      console.log('selectedUsersGroups:', this.selectedUsersGroups);
      
      // Atualizar os dados nos elements que são enviados para o backend
      this.elements[this.selected].details = this.checkeds;
      this.elements[this.selected].users_groups = this.selectedUsersGroups.map(group => group.id);
      
      // Também atualizar na workstation para manter consistência
      this.workstation.places[this.selected].details = this.checkeds;
      this.workstation.places[this.selected].users_groups = this.selectedUsersGroups.map(group => group.id);
      
      this.save();
    },
    removeComponent(index) {
      let self = this;

      swal({
        title: "Deseja deletar o registro?",
        text: "Essa operação não pode ser desfeita",
        type: "warning",
        showCancelButton: true,
        confirmButtonColor: "#DD6B55",
        confirmButtonText: "Sim, deletar!",
        showLoaderOnConfirm: true,
        buttons: {
          catch: {
            text: "Não",
            value: "cancel",
            className: "btn-danger",
          },
          confirm: {
            text: "Sim",
            value: "confirm",
          },
        },
      }).then((value) => {
        switch (value) {
          case "cancel":
            swal("Cancelado", "O registro não foi excluido!", "info");
            break;

          case "confirm":
            if (this.workstation.places[index].id == undefined) {
              this.elements.splice(index, 1);
            } else {
              let api =
                self.$store.getters.api +
                "workstations/places/" +
                this.workstation.places[index].id;

              self.$http
                .delete(api)
                .then((response) => {
                  swal("Sucesso", "Registro excluído com sucesso!", "success");
                  this.workstation.places.splice(index, 1);
                  self.elementSelected = {};
                  self.$emit("refresh");
                })
                .catch((error) => {
                  self.$errorMessage(error);
                });
            }
            break;
        }
      });
    },
    save: function () {
      const self = this;
      const api = self.$store.state.api + "workstations/places";

      self.$http
        .post(api, {
          places: self.elements,
          wButton: self.wButton,
          hButton: self.hButton,
          workstation_id: self.workstation.id,
        })
        .then((response) => {
          self.$message("Sucesso", "Posições salvas com sucesso", "success");
          self.elements = [];
          self.elementSelected = {};
          self.isSelected = false;
          self.getWorkstation();
          setTimeout(function () {
            self.elements = self.sizeTreatment(self.workstation.places);
            $(function () {
              $('[data-toggle="tooltip"]').tooltip();
            });
          }, 500);
        })
        .catch((error) => {
          self.$error(error);
        });
    },
    sizeTreatment: function (array) {
      const self = this;
      $.each(array, function (index, value) {
        array[index] = self.calculateDimensions(value);
      });
      return array;
    },
    calculateDimensions: function (obj) {
      let result = {};
      let imageSize = $(".image-size");
      let width = imageSize.width();
      let height = imageSize.height();
      this.card_height = height;

      result.active = false;
      result.top = (obj.top * height) / obj.screen_height;
      result.left = (obj.left * width) / obj.screen_width;
      result.screen_width = width;
      result.screen_height = height;
      result.width = (obj.width * width) / obj.screen_width;
      result.height = (obj.height * height) / obj.screen_height;
      result.workstation_id = obj.workstation_id;
      result.id = obj.id ? obj.id : null;
      result.title = obj.title ? obj.title : null;
      result.details = obj.details ? obj.details : null;
      result.lock = obj.lock ? obj.lock : null;
      result.users_groups = obj.users_groups ? obj.users_groups : null;

      return result;
    },
    updateElement: function (elem, response) {
      const self = this;
      const api = self.$store.state.api + "machine-equipments/remove";

      self.$http
        .post(api, {
          machine_id: self.$route.params.id,
          equipment_id: elem.equipment_id,
        })
        .then(() => {
          response();
        })
        .catch((error) => {
          self.$error("Não foi possível remover o registro");
        });
    },
    lockRoom: function () {
      $("#modalBloqueioCenter").modal("hide");
      let self = this;
      let id = self.$route.params.id;
      let api = self.$store.state.api + "workstation_place_locks/";

      setTimeout(function () {
        self.lock.place_id = self.elementSelected.id;

        self.$http
          .post(api, self.lock)
          .then((response) => {
            self.elements = [];
            self.elementSelected = {};
            self.isSelected = false;
            self.getWorkstation();
            setTimeout(function () {
              self.elements = self.sizeTreatment(self.workstation.places);
              $(function () {
                $('[data-toggle="tooltip"]').tooltip();
              });
            }, 1000);
            self.$message("Sucesso", `Bloqueio criado com sucesso`, "success");
          })
          .catch((error) => {
            self.errors = error.response.data;
            self.$message(null, self.errors, "error");
          });
      }, 1000);
    },
    deleteLockRoom: function (id) {
      $("#modalBloqueioCenter").modal("hide");
      let self = this;
      let api = self.$store.state.api + "workstation_place_locks/" + id;

      setTimeout(function () {
        self.$http
          .delete(api)
          .then((response) => {
            self.elements = [];
            self.elementSelected = {};
            self.isSelected = false;
            self.getWorkstation();
            setTimeout(function () {
              self.elements = self.sizeTreatment(self.workstation.places);
              $(function () {
                $('[data-toggle="tooltip"]').tooltip();
              });
            }, 1000);
            self.$message(
              "Sucesso",
              `Bloqueio removido com sucesso`,
              "success"
            );
          })
          .catch((error) => {
            self.errors = error.response.data;
            self.$message(null, self.errors, "error");
          });
      }, 1000);
    },
    getUsersGroups: function () {
      const self = this;
      const api = self.$store.state.api + "users_groups/?paginated=false";

      self.$http
        .get(api)
        .then((response) => {
          self.usersGroups = response.data.data;
        })
        .catch((error) => {
          self.$message(null, error.response.data, "error");
        });
    },
    loadPlaceUsersGroups: function (placeId) {
      const self = this;
      const api = self.$store.state.api + "workstation-places/" + placeId + "/users-groups";

      self.$http
        .get(api)
        .then((response) => {
          // Mapear os grupos recebidos para o formato do v-select
          self.selectedUsersGroups = response.data.map(group => {
            return {
              id: group.id,
              title: group.title
            };
          });
        })
        .catch((error) => {
          console.log("Erro ao carregar grupos da posição:", error);
          self.selectedUsersGroups = [];
        });
    },
  },
  mounted: function () {
    this.getWorkstation();
    this.getUsersGroups();

    setTimeout(function () {
      $(function () {
        $('[data-toggle="tooltip"]').tooltip();
      });
    }, 500);
  },
};
</script>

<style scoped>
.vdr {
  align-items: center;
  background: rgba(13, 80, 139, 0.4);
  /* border: 3px solid #0d508b; */
  border-radius: 20px;
}

.top-container {
  width: 100%;
  height: auto;
  position: relative;
}

.top-container img {
  width: 100%;
  height: auto;
  position: relative;
}

input[type="checkbox"] {
  position: absolute;
  z-index: -1;
  opacity: 0;
}

input[type="checkbox"]+label {
  font-size: 12px;
  padding: 2px 0 0;
  width: 100%;
  max-height: 100%;
  border: 2px solid #4b2e8f;
  border-radius: 0.25rem;
}

input[type="checkbox"]:checked+label {
  border: 2px solid #4b2e8f;
  color: #fff;
  background-color: #4b2e8f;
  font-style: normal;
}

.btn-xsm {
  width: 31px;
  height: 23px;
  font-size: 10px;
}

.btn-xsm i {
  margin-left: -2px;
}

.btnD {
  border: 0px !important;
  border-radius: 2px;
}

   </style>



// WEBPACK FOOTER //
// src/components/Workstations/Configuration.vue